<template>
  <div>
    <div v-loading="loading">
      <el-form
        ref="form"
        :model="formData"
        label-width="120px"
        label-position="top"
        size="small"
        :rules="rules"
      >
        <div class="d-flex">
          <div class="pr-1">
            <el-image
              :src="defaultImageUrl"
              :preview-src-list="[defaultImageUrl]"
              style="width:120px; height:119px"
            >
              <div slot="error" class="image-slot">
                <img
                  src="/image/static/img/nopic.jpg"
                  style="width:120px; height:119px"
                />
              </div>
            </el-image>
          </div>
          <div style="flex:1">
            <div class="el-descriptions">
              <div class="el-descriptions__body descriptions__body_header">
                <div
                  class="el-descriptions__table is-bordered el-descriptions--small"
                >
                  <div class="el-descriptions-row">
                    <div
                      class="el-descriptions-item__cell el-descriptions-item__label is-bordered-label bg-white"
                    >
                      <div class="sku_main">
                        <div>
                          <span v-if="formData.goodsName">
                            {{ formData.goodsName }}
                          </span>
                          <span v-if="formData.goodsNameEn">
                            {{ formData.goodsNameEn }}
                          </span>
                          <span v-if="formData.masterCategoryName">
                            {{ `(${formData.masterCategoryName})` }}
                          </span>
                        </div>
                        <div>
                          <span v-if="formData.amzSkuNo">
                            {{ formData.amzSkuNo }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <el-descriptions
              border
              size="small"
              class="bottom-desc"
              :column="2"
            >
              <el-descriptions-item
                :label="$l('form_label_SPU') || 'SPU'"
                :labelStyle="{ width: '140px' }"
                :contentStyle="{ width: '200px' }"
              >
                {{ formData.amzSpuNo }}
              </el-descriptions-item>
              <el-descriptions-item
                :label="$l('form_label_brandName') || '品牌'"
                :labelStyle="{ width: '140px' }"
                :contentStyle="{ width: '200px' }"
              >
                {{ formData.brandName }}
              </el-descriptions-item>
              <el-descriptions-item
                :label="$l('form_label_collectionName') || '系列'"
                :labelStyle="{ width: '140px' }"
                :contentStyle="{ width: '200px' }"
              >
                {{ formData.collectionName }}
              </el-descriptions-item>
              <el-descriptions-item
                :label="$l('form_label_categoryFullName') || '品类'"
                :labelStyle="{ width: '140px' }"
                :contentStyle="{ width: '200px' }"
              >
                {{ formData.categoryFullName }}
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
        <div class="d-flex pt_6 mt-2">
          <div class="side-frame"></div>
          <div>
            <span style="font-size: 14px; color: #606266">
              {{
                $l('table_target_product_rate_setting') || '目标及产品费率设置'
              }}
            </span>
          </div>
        </div>

        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_regionName') || '目标市场'"
              prop="regionCode"
            >
              <dict-select
                v-model="formData.regionCode"
                :selectedLabel.sync="formData.regionName"
                url="/master/common/dict/biz"
                :body="{ dictType: 'region' }"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_topOneDailyQty') || '小类TOP1日销'"
              prop="topOneDailyQty"
            >
              <el-input-number
                v-model="formData.topOneDailyQty"
                controls-position="right"
                :step="1"
                :min="0"
                style="width:100%"
                v-el-inputnumber-default0
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_targetRank') || '目标小类排名'"
              prop="targetRank"
            >
              <el-input-number
                v-model="formData.targetRank"
                controls-position="right"
                :step="1"
                :min="0"
                style="width:100%"
                v-el-inputnumber-default0
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_targetDailyQty') || '排名应对日销'"
              prop="targetDailyQty"
            >
              <el-input-number
                v-model="formData.targetDailyQty"
                controls-position="right"
                :step="1"
                :min="0"
                style="width:100%"
                v-el-inputnumber-default0
              >
              </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_AmzReferralRatio') || 'Amz推荐费率'"
              prop="amzReferralRatio"
            >
              <el-input-number
                v-model="formData.amzReferralRatio"
                controls-position="right"
                :step="1"
                :min="0"
                :precision="2"
                style="width:100%"
                v-el-inputnumber-default0
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_perFbaFreight') || '单个产品物流费'"
              prop="perFbaFreight"
            >
              <el-input-number
                v-model="formData.perFbaFreight"
                controls-position="right"
                :step="1"
                :min="0"
                style="width:100%"
                v-el-inputnumber-default0
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_perStorageFee') || '单个产品仓储费'"
              prop="perStorageFee"
            >
              <el-input-number
                v-model="formData.perStorageFee"
                controls-position="right"
                :step="1"
                :min="0"
                style="width:100%"
                v-el-inputnumber-default0
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_perReturnFee') || '单个产品退货费'"
              prop="perReturnFee"
            >
              <el-input-number
                v-model="formData.perReturnFee"
                controls-position="right"
                :step="1"
                :min="0"
                style="width:100%"
                v-el-inputnumber-default0
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_perCost') || '单个产品成本'"
              prop="perCost"
            >
              <el-input-number
                v-model="formData.perCost"
                controls-position="right"
                :step="1"
                :min="0"
                style="width:100%"
                v-el-inputnumber-default0
              >
              </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="d-flex pt_6 mt-2">
          <div class="side-frame-success"></div>
          <div>
            <span style="font-size: 14px; color: #606266">
              {{ $l('table_six_month') || '6个月销量预估' }}
            </span>
          </div>
        </div>
        <PredictTable
          ref="predictTable"
          class="mt-1"
          :amzFirstDemandCode="amzFirstDemandCode"
          :disabled="disabled"
          @reset="getData"
          highlightCurrentRow
          @onCellClick="onCellClick"
          @initCurrentRow="onInitCurrentRow"
        />
        <div class="d-flex pt_6 mt-2">
          <div class="side-frame-success"></div>
          <div>
            <span style="font-size: 14px; color: #606266">
              {{ `第 ${formData.predictMonth || '1'} 个月销售预估` }}
            </span>
          </div>
          <div @click="formulatDescriptionDialogVisible = true" class="ml-4">
            <span style="font-size: 14px; color: #007BFF;font-weight: 600;">
              {{ '填报公式说明' }}
            </span>
          </div>
        </div>

        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_avgPrice') || '平均售价'"
              prop="avgPrice"
            >
              <el-input-number
                v-model="formData.avgPrice"
                controls-position="right"
                :step="1"
                :min="0"
                :precision="2"
                style="width:100%"
                v-el-inputnumber-default0
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_saleQty') || '月销量'"
              prop="saleQty"
            >
              <el-input-number
                v-model="formData.saleQty"
                controls-position="right"
                :step="1"
                :min="0"
                style="width:100%"
                v-el-inputnumber-default0
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_saleAmount') || '月销售额'"
              prop="saleAmount"
            >
              <el-input v-model="saleAmount" readonly style="width:100%">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_saleRank') || '小类排名'"
              prop="saleRank"
            >
              <el-input-number
                v-model="formData.saleRank"
                controls-position="right"
                :step="1"
                :min="0"
                style="width:100%"
                v-el-inputnumber-default0
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_advRatio') || '广销比'"
              prop="advRatio"
            >
              <el-input-number
                v-model="formData.advRatio"
                controls-position="right"
                :step="1"
                :min="0"
                :precision="2"
                style="width:100%"
                v-el-inputnumber-default0
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_advAmount') || '广告花费'"
              prop="advAmount"
            >
              <el-input v-model="advAmount" readonly style="width:100%">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_inSiteFee') || '站内费用'"
              prop="inSiteFee"
            >
              <el-input-number
                v-model="formData.inSiteFee"
                controls-position="right"
                :step="1"
                :min="0"
                :precision="2"
                style="width:100%"
                v-el-inputnumber-default0
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_outSiteFee') || '站外费用'"
              prop="outSiteFee"
            >
              <el-input-number
                v-model="formData.outSiteFee"
                controls-position="right"
                :step="1"
                :min="0"
                :precision="2"
                style="width:100%"
                v-el-inputnumber-default0
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_amzReferralFee') || 'Amz推荐费'"
              prop="amzReferralFee"
            >
              <el-input v-model="amzReferralFee" readonly style="width:100%">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_fbaFreight') || 'FBA物流费'"
              prop="fbaFreight"
            >
              <el-input v-model="fbaFreight" readonly style="width:100%">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_storageFee') || '仓储费'"
              prop="storageFee"
            >
              <el-input v-model="storageFee" readonly style="width:100%">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_returnFee') || '退货费'"
              prop="returnFee"
            >
              <el-input v-model="returnFee" readonly style="width:100%">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_operateProfit') || '平台运营利润'"
              prop="operateProfit"
            >
              <el-input v-model="operateProfit" readonly style="width:100%">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_operateProfitRatio') || '运营利润率'"
              prop="operateProfitRatio"
            >
              <el-input
                v-model="operateProfitRatio"
                readonly
                style="width:100%"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_goodsCost') || '产品成本'"
              prop="goodsCost"
            >
              <el-input v-model="goodsCost" readonly style="width:100%">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_monthProfit') || '当月销售利润'"
              prop="monthProfit"
            >
              <el-input v-model="monthProfit" readonly style="width:100%">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_monthProfitRatio') || '综合销售利润率'"
              prop="monthProfitRatio"
            >
              <el-input v-model="monthProfitRatio" readonly style="width:100%">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_addUpProfit') || '累计销售利润'"
              prop="addUpProfit"
            >
              <el-input v-model="addUpProfit" readonly style="width:100%">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="saveAndClose()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="updatePredictDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="notSave()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="updatePredict()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      append-to-body
      :title="$l('dialog_title_formula_description') || '填报公式说明'"
      :visible.sync="formulatDescriptionDialogVisible"
      width="890px"
      center
    >
      <div style="font-size: 14px;color: #464646;">
        <el-row :gutter="20">
          <el-col :span="8"
            ><span class="label">月销售额</span> = 平均售价 * 月销量</el-col
          >
          <el-col :span="8"
            ><span class="label">广告花费</span> = 月销售额 * 广销比</el-col
          >
          <el-col :span="8"
            ><span class="label">Amz推荐费</span> = 月销售额 *
            Amz推荐费率</el-col
          >
        </el-row>
        <el-row :gutter="20" class="mt-4">
          <el-col :span="8"
            ><span class="label">FBA物流费</span> = 月销量 *
            单个产品物流费</el-col
          >
          <el-col :span="8"
            ><span class="label">仓储费</span> = 月销量 *
            单个产品仓储费用</el-col
          >
          <el-col :span="8"
            ><span class="label">退货费</span> = 月销量 *
            单个产品退货费用</el-col
          >
        </el-row>
        <el-row :gutter="20" class="mt-4">
          <el-col :span="24">
            <span class="label">平台运营利润</span> = 月销售额 - 广告费 -
            站内费用 - 站外费用 - Amz推荐费 - FBA物流费用 - 仓储费 - 退货费
          </el-col>
        </el-row>
        <el-row :gutter="20" class="mt-4">
          <el-col :span="8"
            ><span class="label">运营利润率</span> = 平台运营利润 /
            月销售额</el-col
          >
          <el-col :span="8"
            ><span class="label">产品成本</span> = 月销量 * 单品成本</el-col
          >
          <el-col :span="8"
            ><span class="label">当月销售利润</span> = 平台运营利润 -
            产品成本</el-col
          >
        </el-row>
        <el-row :gutter="20" class="mt-4">
          <el-col :span="8"
            ><span class="label">综合销售利润率</span> = 当月销售利润 /
            月销售额</el-col
          >
          <el-col :span="16"
            ><span class="label">累计销售利润</span> = 上月累计销售利润 +
            当月销售利润</el-col
          >
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="formulatDescriptionDialogVisible = false"
          size="small"
        >
          {{ $l('INDEX.btn_close') || '关闭' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import PredictTable from './predict-table'
import {
  add,
  subtract,
  multiplyDown,
  divide,
  divideDown,
} from '@/libs/util.number.js'
import validate from '@/libs/util.validate'
export default {
  mixins: [EditLoading],
  components: { PredictTable },
  props: {
    disabled: { type: Boolean, default: false },
    amzFirstDemandCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      tmpData: {},
      loading: false,
      backDialogVisible: false,
      updatePredictDialogVisible: false,
      formulatDescriptionDialogVisible: false,
      rules: {
        regionCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        topOneDailyQty: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        targetRank: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        targetDailyQty: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        amzReferralRatio: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        perFbaFreight: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        perStorageFee: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        perReturnFee: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        perCost: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        avgPrice: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        saleQty: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        saleAmount: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        saleRank: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        advRatio: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        advAmount: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        inSiteFee: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        outSiteFee: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        amzReferralFee: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        fbaFreight: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        storageFee: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        returnFee: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        operateProfit: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        operateProfitRatio: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        goodsCost: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        monthProfit: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        monthProfitRatio: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        addUpProfit: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    saleAmount() {
      return multiplyDown(this.formData.avgPrice, this.formData.saleQty, 2)
    },
    advAmount() {
      return multiplyDown(
        this.saleAmount,
        divide(this.formData.advRatio, 100),
        2
      )
    },
    amzReferralFee() {
      return multiplyDown(
        this.saleAmount,
        divide(this.formData.amzReferralRatio, 100),
        2
      )
    },
    fbaFreight() {
      return multiplyDown(this.formData.perFbaFreight, this.formData.saleQty, 2)
    },
    storageFee() {
      return multiplyDown(this.formData.perStorageFee, this.formData.saleQty, 2)
    },
    returnFee() {
      return multiplyDown(this.formData.perReturnFee, this.formData.saleQty, 2)
    },
    operateProfit() {
      return subtract(
        subtract(
          subtract(
            subtract(this.saleAmount, add(this.advAmount, this.amzReferralFee)),
            add(this.formData.inSiteFee, this.formData.outSiteFee)
          ),
          add(this.fbaFreight, this.storageFee)
        ),
        this.returnFee
      )
    },
    operateProfitRatio() {
      return multiplyDown(
        divideDown(this.operateProfit, this.saleAmount, 4),
        100,
        2
      )
    },
    goodsCost() {
      return multiplyDown(this.formData.perCost, this.formData.saleQty, 2)
    },
    monthProfit() {
      return subtract(this.operateProfit, this.goodsCost)
    },
    monthProfitRatio() {
      return multiplyDown(
        divideDown(this.monthProfit, this.saleAmount, 4),
        100,
        2
      )
    },
    addUpProfit() {
      return add(this.formData.preMonthProfit, this.monthProfit)
    },
    defaultImageUrl() {
      const { defaultImageUrl } = this.formData
      return defaultImageUrl
        ? this.$osscdn(defaultImageUrl)
        : '/image/static/img/nopic.jpg'
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.loading = true
      await this.getData()
      this.loading = false
    },
    async getData() {
      if (!this.amzFirstDemandCode) return
      const res = await this.$api
        .ecomAmzFirstDemandSpuDetailApi({
          amzFirstDemandCode: this.amzFirstDemandCode,
        })
        .catch(() => null)
      const data = res?.body || {}
      this.formData = { ...data, ...this.tmpData }
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
      this.$emit('reset')
    },
    notSave() {
      this.updatePredictDialogVisible = false
      this.formData = { ...this.formData, ...this.tmpData }
    },
    async updatePredict() {
      await this.save()
      this.formData = { ...this.formData, ...this.tmpData }
    },
    async saveAndClose() {
      await this.save()
      this.close()
    },
    async saveConfirm() {
      this.backDialogVisible = false
      const baseForm = await validate.formValidate([this.$refs.form])
      if (!baseForm) {
        return
      }
      if (this.loadingOpen()) return
      this.formData.saleAmount = this.saleAmount
      this.formData.advAmount = this.advAmount
      this.formData.amzReferralFee = this.amzReferralFee
      this.formData.fbaFreight = this.fbaFreight
      this.formData.storageFee = this.storageFee
      this.formData.returnFee = this.returnFee
      this.formData.operateProfit = this.operateProfit
      this.formData.operateProfitRatio = this.operateProfitRatio
      this.formData.goodsCost = this.goodsCost
      this.formData.monthProfit = this.monthProfit
      this.formData.monthProfitRatio = this.monthProfitRatio
      this.updatePredictDialogVisible = false
      const res = await this.$api
        .ecomAmzFirstDemandPredictUpdateApi({
          ...this.formData,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || res.msg,
        type: 'success',
      })
      await this.$refs.predictTable.getData()
      this.formData = { ...this.formData, ...this.tmpData }
    },
    async save() {
      this.backDialogVisible = false
      const baseForm = await validate.formValidate([this.$refs.form])
      if (!baseForm) {
        this.formData = { ...this.formData, ...this.tmpData }
        return
      }
      if (this.loadingOpen()) return
      this.formData.saleAmount = this.saleAmount
      this.formData.advAmount = this.advAmount
      this.formData.amzReferralFee = this.amzReferralFee
      this.formData.fbaFreight = this.fbaFreight
      this.formData.storageFee = this.storageFee
      this.formData.returnFee = this.returnFee
      this.formData.operateProfit = this.operateProfit
      this.formData.operateProfitRatio = this.operateProfitRatio
      this.formData.goodsCost = this.goodsCost
      this.formData.monthProfit = this.monthProfit
      this.formData.monthProfitRatio = this.monthProfitRatio
      this.updatePredictDialogVisible = false
      const res = await this.$api
        .ecomAmzFirstDemandPredictUpdateApi({
          ...this.formData,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      await this.$refs.predictTable.getData()
      this.formData = { ...this.formData, ...this.tmpData }
    },
    onInitCurrentRow(row) {
      this.tmpData = { ...row }
      this.formData = { ...this.formData, ...row }
    },
    async onCellClick(row) {
      this.tmpData = { ...row }
      await this.save()
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .bottom-desc {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }
}
.sku_main {
  font-size: 16px;
  font-weight: bold;
  color: #101010;
  height: 31px;
  line-height: 31px;
}

.bg-white {
  background-color: white !important;
}
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 3px;
}
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.label {
  font-weight: 600;
  color: #101010;
}
</style>
